module.exports = __webpack_public_path__ + "media/books/ArtBooks-240bcdac.jpg";